<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import formdate from "@/router/views/formcomponet/formdate.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import okurumteklif from "@/models/okurumteklif";
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, okurumteklif],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput, treeselect, Multiselect, formdate, formtextarea
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  computed: {
    moduleSelectOptions() {
      const arr = this.FormDataType?.Modulids?.ComboDataArray
      if (!Array.isArray(arr)) return []

      return arr
        .filter(x => x && x.id)
        .map(item => ({
          value: String(item.id),
          label: item.label || ""
        }))
    }
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("okurumteklif", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.okurumteklifData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("okurumteklif", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.okurumteklifData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() { },

    FileUpload(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf" || uzanti == "tar" || uzanti == "zip") {
        let formData = new FormData();
        formData.append("file", file);
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {
            this.FormData.Dosyayolu = res.Data.filename;
            this.$toast.success("Dosya yüklendi");
          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
  },
};
</script>
<template>
  <b-modal v-model="ModalOpen" id="okurumteklif" size="lg" :title="this.AddEdit == 'Edit'
    ? 'Kayıt Düzenle'
    : 'Yeni Kayıt Ekle'
    " title-class="font-18" hide-footer>
    <Form @submit.prevent="onSubmit" v-if="FormData">

      <div class="row">

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Birimid.FieldTitle"
          :key="FormData.Birimid">
          <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Birimid" />
          <treeselect-value :value="FormData.Birimid" />
        </b-form-group>

        <formdate class="col-lg-6" :FormDataType="FormDataType.Tarih" :Value="FormData.Tarih"
          :v="v$.FormData.Tarih" @input="FormData.Tarih = $event.target.value" />

        <forminput class="col-lg-6" :FormDataType="FormDataType.Tutar" :Value="FormData.Tutar"
          :v="v$.FormData.Tutar" @input="FormData.Tutar = $event.target.value" />

        <forminput class="col-lg-6" :FormDataType="FormDataType.Teklifiveren" :Value="FormData.Teklifiveren"
          :v="v$.FormData.Teklifiveren" @input="FormData.Teklifiveren = $event.target.value" />

        <b-form-group class="col-lg-6" :label="FormDataType.Modulids.FieldTitle">
          <Multiselect v-model="FormData.Modulids" mode="tags" :close-on-select="false" :searchable="true"
            :options="moduleSelectOptions" valueProp="value" label="label" trackBy="label" placeholder="Seçiniz..." />
        </b-form-group>

        <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Durum.FieldTitle"
          :key="FormData.Durum">
          <treeselect :multiple="false" :options="FormDataType.Durum.ComboDataArray" placeholder="Seçiniz..."
            v-model="FormData.Durum" />
          <treeselect-value :value="FormData.Durum" />
        </b-form-group>

        <b-form-group class="col-md-6" label="Belge">
          <input class="form-control upload-input col-md-12 mt-3" ref="file" type="file"
            @change="FileUpload($event)" id="FormData.Dosyayolu"
            accept=".jpg, .jpeg, .png, .pdf, .docx, .xlsx, .tar, .zip" />
        </b-form-group>

        <formtextarea class="col-lg-12" :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama"
          :v="v$.FormData.Aciklama" @input="FormData.Aciklama = $event.target.value" />

      </div>
      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
